var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import VueDialog from "../../interface/IVueDialog";
import LicenseService from "../../api/LicenseService";
import TableHeaderToolTip from '../../common/components/TableHeaderToolTip';
import { ELicenseTypeAttr } from "../../enum/ELicense";
var claimTypeHtml = "\n    <div>\n        <div>\n            <div>\u5E38\u7528\u4F01\u4E1A\u8BC1\u7167\u53CA\u8D27\u54C1\u8BC1\u7167\u793A\u4F8B\uFF1A</div>\n            <ul>\n                <li>\u2022 \u4F01\u4E1A\u8BC1\u7167\uFF1A\u5982\u8425\u4E1A\u6267\u7167\u3001\u751F\u4EA7\u8BB8\u53EF\u8BC1\u3001\u7ECF\u8425\u8BB8\u53EF\u8BC1\u3001\u5B9A\u70B9\u5C60\u5BB0\u8BC1\u3001\u52A8\u7269\u9632\u75AB\u6761\u4EF6\u5408\u683C\u8BC1\u7B49\uFF1B</li>\n                <li>\u2022 \u8D27\u54C1\u8BC1\u7167\uFF0C\u5982\u7B2C\u4E09\u65B9\u68C0\u6D4B\u62A5\u544A\u3001\u51FA\u5382\u6279\u68C0\u62A5\u544A\u3001\u52A8\u7269\u68C0\u75AB\u5408\u683C\u8BC1\u3001\u5165\u5883\u8D27\u7269\u68C0\u9A8C\u68C0\u75AB\u8BC1\u660E\u3001\u8FDB\u53E3\u8D27\u7269\u62A5\u5173\u5355\u7B49\u3002</li>\n            </ul>\n        </div>\n        <div>\n            <div>\u7D22\u8BC1\u7C7B\u578B\u8BF4\u660E\uFF1A</div>\n            <ul>\n                <li>\u2022 \u5B9A\u671F\u63D0\u4F9B\uFF1A\u4E00\u822C\u6307\u5177\u6709\u5468\u671F\u6027\u6548\u671F\u7684\u8BC1\u7167\uFF0C\u5B9A\u671F\u63D0\u4EA4\u5BA2\u6237\u5373\u53EF\uFF1B</li>\n                <li>\u2022 \u968F\u5355\u63D0\u4F9B\uFF1A\u4E00\u822C\u6307\u4EC5\u5F53\u6B21\u6709\u6548\u7684\u8D27\u54C1\u6279\u6B21\u8BC1\u7167\uFF0C\u5BA2\u6237\u8981\u6C42\u4F9B\u5E94\u5546\u968F\u5355\u63D0\u4F9B\u8BC1\u660E\uFF1B</li>\n                <li>\u2022 \u4F01\u4E1A\u8BC1\u7167\u9ED8\u8BA4\u4E3A\u5B9A\u671F\u63D0\u4F9B\uFF0C\u4E0D\u53EF\u66F4\u6539\u3002</li>\n            </ul>\n        </div>\n    </div>\n";
var LicenseTypeDialog = (function (_super) {
    __extends(LicenseTypeDialog, _super);
    function LicenseTypeDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eLicenseTypeAttr = ELicenseTypeAttr;
        _this.listData = [];
        _this.tableHeight = 400;
        return _this;
    }
    LicenseTypeDialog.prototype.created = function () {
        this.service = LicenseService.getInstance();
        this.getList();
    };
    LicenseTypeDialog.prototype.mounted = function () {
    };
    LicenseTypeDialog.prototype.getList = function () {
        var _this = this;
        this.service.getDocumentTypeList().then(function (res) {
            if (res.data.success) {
                _this.listData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    LicenseTypeDialog.prototype.close = function () {
        var _this = this;
        this.$confirm("您修改的内容尚未保存，确定要放弃这些内容吗?", "提示", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function (res) {
            if (res) {
                _this.$closeDialog();
            }
        }).catch(function () { });
    };
    LicenseTypeDialog.prototype.save = function () {
        var _this = this;
        var data = this.listData.map(function (v) {
            return {
                document_type_id: v.document_type_id,
                claim_type: v.claim_type
            };
        });
        var params = { data: data };
        this.service.multiModifyClaimType(params).then(function (res) {
            if (res.data.success) {
                _this.$message.success('保存成功！');
                _this.$emit('save_liscense_type:ok');
                _this.$closeDialog();
            }
            else {
                _this.$message.error(res.data.msg);
            }
        });
    };
    LicenseTypeDialog = __decorate([
        Component({
            components: {
                TableHeaderToolTip: TableHeaderToolTip
            },
            methods: {
                renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: claimTypeHtml,
                            placement: "bottom"
                        }
                    }, '索证类型');
                }
            }
        })
    ], LicenseTypeDialog);
    return LicenseTypeDialog;
}(VueDialog));
export default LicenseTypeDialog;
